import React, { useState } from 'react';
const faqs = [{
  emoji: '📦',
  question: '¿Qué estoy comprando exactamente?',
  answer: 'Acceso a un programa digital de negocios gastronómicos. Incluye el Manual Central, el <b>Kit Pro 7×1</b> (herramientas editables) y <b>10 bonos</b> de especialización. Todo descargable e inmediato.'
}, {
  emoji: '⚡',
  question: '¿Tengo que saber cocinar profesionalmente?',
  answer: 'No. El sistema se basa en recetas simples, rentables y de ensamblaje fácil. Lo importante acá es el <b>modelo de negocio</b>, no ser una chef Michelin.'
}, {
  emoji: '🌱',
  question: '¿Realmente puedo empezar sin plata?',
  answer: 'Sí. Enseñamos la técnica de <b>Pre-Venta Financiada</b>. Tomás los pedidos, cobrás una seña o el total, y con ESE dinero comprás los insumos. Cero riesgo de tu bolsillo.'
}, {
  emoji: '🐻🔍',
  question: '¿Sirve si tengo poco tiempo por mis hijos?',
  answer: 'Está diseñado para eso. Con el método de <b>Producción en Bloque</b>, concentrás el trabajo sucio en 1 o 2 días y el resto de la semana solo despachás y vendés.'
}, {
  emoji: '🧐',
  question: '¿Cómo calculo los precios con esta inflación?',
  answer: 'El Kit incluye una <b>Calculadora Automatizada en Excel</b>. Solo ponés el precio del insumo hoy y te dice cuánto cobrar para mantener tu ganancia intacta.'
}, {
  emoji: '🏢',
  question: '¿Necesito local o habilitación ya?',
  answer: 'No para empezar. Te enseñamos cómo iniciar desde tu cocina bajo la figura de "Cocina Domiciliaria" y cómo escalar a la formalidad paso a paso cuando ya estés facturando.'
}, {
  emoji: '❌',
  question: '¿Y si no me funciona?',
  answer: 'Tenés una <b>Garantía de 30 días</b>. Si aplicás el método y no ves resultados (o simplemente no es lo que esperabas), te devolvemos tu dinero sin preguntas.'
}];
export function GuaranteeAndFaq() {
  const [openIndexes, setOpenIndexes] = useState<Set<number>>(new Set());
  const toggle = (index: number) => {
    setOpenIndexes(prev => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };
  return <section className="w-full bg-white px-4 md:px-8 py-16" data-id="element-164">
      <div className="max-w-[800px] mx-auto" data-id="element-165">
        {/* Guarantee */}
        <div className="text-center mb-16" data-id="element-166">
          <h2 className="font-['Playfair_Display',_serif] text-2xl md:text-3xl lg:text-[36px] font-bold text-[#1a1a1a] leading-tight mb-3" data-id="element-167">
            Garantía Blindada de 30 Días
          </h2>
          <div className="w-16 h-1 bg-[#4caf50] mx-auto mb-6" data-id="element-168"></div>

          <p className="font-['Montserrat',_sans-serif] text-[#555] text-base md:text-lg mb-8 max-w-[500px] mx-auto" data-id="element-169">
            Estamos tan seguros de que este sistema funciona, que asumimos todo
            el riesgo. Si no recuperás tu inversión o no te gusta, te devolvemos
            el 100%.
          </p>

          {/* Guarantee badge */}
          <div className="inline-flex items-center gap-4 bg-[#f9f8f4] rounded-xl px-6 py-4 border border-gray-200" data-id="element-170">
            <div className="w-14 h-14 rounded-full flex-shrink-0 overflow-hidden" data-id="element-171">
              <img src="https://cdn.magicpatterns.com/uploads/rXB8c3Fhjwh5LUY3gUM832/Captura_de_pantalla_2026-04-30_a_las_9.18.37_p._m..png" alt="Garantía 30 días" className="w-full h-full object-cover" data-id="element-172" />
            </div>
            <div className="text-left" data-id="element-173">
              <p className="font-['Montserrat',_sans-serif] text-[#4caf50] font-bold text-base" data-id="element-174">
                Garantía de Satisfacción Total
              </p>
              <p className="font-['Montserrat',_sans-serif] text-[#555] text-sm" data-id="element-175">
                Probá el sistema por 30 días sin riesgo
              </p>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div data-id="element-176">
          <h2 className="font-['Playfair_Display',_serif] text-2xl md:text-3xl font-bold text-[#1a1a1a] text-center mb-8" data-id="element-177">
            Preguntas Frecuentes (FAQ)
          </h2>

          <div className="space-y-3" data-id="element-178">
            {faqs.map((faq, index) => <div key={index} className="rounded-xl overflow-hidden shadow-[0_2px_8px_rgba(76,175,80,0.08)]" data-id="element-179">
                <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-5 py-4 text-left" style={{
              background: 'linear-gradient(90deg, #e8f5e9 0%, #f1f8f1 30%, #f9faf9 60%, #ffffff 100%)'
            }} data-id="element-180">
                  <span className="font-['Montserrat',_sans-serif] text-[#1a1a1a] font-bold text-sm md:text-base" data-id="element-181">
                    {faq.emoji} {faq.question}
                  </span>
                  <span className="text-[#4caf50] font-bold text-xl flex-shrink-0 ml-4" data-id="element-182">
                    {openIndexes.has(index) ? '−' : '+'}
                  </span>
                </button>
                {openIndexes.has(index) && faq.answer && <div className="px-5 pb-4 pt-2 bg-white" data-id="element-183">
                    <p className="font-['Montserrat',_sans-serif] text-[#555] text-sm md:text-base leading-relaxed" dangerouslySetInnerHTML={{
                __html: faq.answer
              }} data-id="element-184" />
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}